import AuthGuard from './AuthGuard';
import create from './Guards/create';
import readUpdateDelete from './Guards/readUpdateDelete';

export default AuthGuard;
export { create, readUpdateDelete };
